import React, { useMemo } from "react";
import {
  IconCar,
  IconCheck,
  IconDatabaseCog,
  IconAlertTriangle,
  IconSettings,
  IconInfoCircle,
  IconClock,
} from "@tabler/icons-react";
import { STATUS_COLORS } from "../utils/statusUtils";

const SummaryStats = ({ vehicles, filterStatus, onStatusFilter, statuses }) => {
  // Generate stats dynamically from available statuses
  const stats = useMemo(
    () =>
      statuses.map((status, index) => ({
        id: status.id,
        label: status.name,
        count: vehicles.filter((v) => String(v.status_id) === String(status.id))
          .length,
        color: STATUS_COLORS[index % STATUS_COLORS.length],
        bgColor: `${STATUS_COLORS[index % STATUS_COLORS.length]}20`,
        icon: getIconComponent(index),
      })),
    [vehicles, statuses]
  );

  // Add "All" option
  const allStats = useMemo(
    () => ({
      id: "all",
      label: "All Vehicles",
      count: vehicles.length,
      color: "#6b7280",
      bgColor: "#6b728020",
      icon: IconCar,
    }),
    [vehicles]
  );

  const allStatsArray = useMemo(() => [allStats, ...stats], [allStats, stats]);

  return (
    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-4 g-2">
      {allStatsArray.map((stat) => {
        const IconComponent = stat.icon;
        const isActive = filterStatus === String(stat.id);

        return (
          <div key={stat.id} className="col">
            <div
              className={`card cursor-pointer transition-all ${
                isActive ? "border-primary bg-primary-lt" : "border"
              }`}
              onClick={() =>
                onStatusFilter(
                  filterStatus === String(stat.id) ? "all" : String(stat.id)
                )
              }
            >
              <div className="card-body">
                <div className="d-flex align-items-center gap-3">
                  <div
                    className="d-flex align-items-center justify-content-center rounded"
                    style={{
                      width: "48px",
                      height: "48px",
                      backgroundColor: stat.bgColor,
                    }}
                  >
                    <IconComponent size={24} color={stat.color} />
                  </div>
                  <div className="flex-fill">
                    <p className="text-muted mb-0 fs-6">{stat.label}</p>
                    <p className="fw-bold mb-0 fs-1">{stat.count}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

// Helper function to map status index to Tabler icon component
const getIconComponent = (index) => {
  const icons = [
    IconCheck,
    IconDatabaseCog,
    IconAlertTriangle,
    IconSettings,
    IconInfoCircle,
    IconClock,
  ];
  return icons[index % icons.length];
};

export default SummaryStats;
